import { connectFela } from '../../dependencies';
import CompanyForm from './CompanyForm';
import * as styles from './CompanyForm.styles';

export default connectFela(styles)(CompanyForm);
